module.exports = __webpack_public_path__ + "static/media/breedCut-01.45025f66.png";